import { Box, Stack } from '@mui/material';
import { type FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useVoice } from '../../contexts/VoiceContext';
import {
  VOICE_COMMAND_DOCS,
  hintVisibleParams,
  trySayingSuffix,
} from '../../data/voiceCommandsDocs';
import { voiceCommandsDocsPath } from '../../navigation/paths';
import { VoiceModalListeningHintsDocsLink } from './VoiceModalListeningHintsDocsLink';
import { VoiceModalListeningHintsDotBar } from './VoiceModalListeningHintsDotBar';
import { VoiceModalListeningHintsExampleRow } from './VoiceModalListeningHintsExampleRow';
import { VoiceModalListeningHintsHeading } from './VoiceModalListeningHintsHeading';
import { VoiceModalListeningHintsParamChips } from './VoiceModalListeningHintsParamChips';

const ROTATE_INTERVAL_MS = 6000;
const DOC_COUNT = VOICE_COMMAND_DOCS.length;

export const VoiceModalListeningHints: FC = () => {
  useTranslation();
  const navigate = useNavigate();
  const { cancel } = useVoice();
  const [idx, setIdx] = useState(() => Math.floor(Math.random() * DOC_COUNT));

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % DOC_COUNT), ROTATE_INTERVAL_MS);
    return () => clearInterval(t);
  }, []);

  const cmd = VOICE_COMMAND_DOCS[idx];
  const { chips, moreCount } = hintVisibleParams(cmd);
  const trySuffix = trySayingSuffix(cmd);

  const openDocs = () => {
    cancel();
    navigate({ pathname: voiceCommandsDocsPath, search: `?cmd=${cmd.id}` });
  };

  return (
    <Box
      sx={{
        mt: 2,
        pt: 1.5,
        pb: 1.5,
        textAlign: 'center',
        borderTop: '1px solid var(--tg-theme-section-separator-color)',
      }}
    >
      <VoiceModalListeningHintsHeading />
      <Stack
        key={idx}
        direction="column"
        alignItems="center"
        gap={1}
        sx={{ animation: 'voiceSlideFromRight 0.4s ease-out' }}
      >
        <VoiceModalListeningHintsExampleRow cmd={cmd} trySuffix={trySuffix} />
        <VoiceModalListeningHintsParamChips cmd={cmd} chips={chips} moreCount={moreCount} />
        <VoiceModalListeningHintsDocsLink onOpenDocs={openDocs} />
      </Stack>
      <VoiceModalListeningHintsDotBar activeIndex={idx} onSelectIndex={setIdx} />
    </Box>
  );
};
